import { IGetReportContratoFinanceiroListaUseCase } from "../../../presentation/useCases/read/get_report_contrato_financeiro_use_case";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import dayjs from "dayjs";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";

/**
 * GetReportContratoFinanceiroListaUseCase
 */


export class GetReportContratoFinanceiroListaUseCase implements IGetReportContratoFinanceiroListaUseCase {

  constructor(private readonly repository: IReportsRepository) { }

  async execute(requiredMimeType: ReportMimeType | null): Promise<ReportData> {
    const response = await this.repository.getReportContratoFinanceiroLista(requiredMimeType);

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `contrato_financeiro_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;

  }

}
